import { render, staticRenderFns } from "./PenalidadeForm.vue?vue&type=template&id=2ea93fb3"
import script from "./PenalidadeForm.vue?vue&type=script&lang=js"
export * from "./PenalidadeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports